import type { AccountPlan } from '../types'

export function ownerAdsEligible(plan: Pick<AccountPlan, 'ownerAdsEnabled'> | null | undefined): boolean {
  return Boolean(plan?.ownerAdsEnabled)
}
